export const cleanFetchCollection = (data = {}) => {
  const fetchFinalData = Object.values(data?.content ?? {}).filter(
    (value) =>
      typeof value === "object" && !Array.isArray(value) && value !== null
  )

  return fetchFinalData
}
